import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { selectors as streamSelectors } from '../../Stream';
const statMap = {
    comment: 'comments',
    favourite: 'favourites'
};
function getStreamIdForType(type, deviationId) {
    return `@@who:${deviationId}:${type}`;
}
function getTotal(state, type, deviation) {
    const streamId = getStreamIdForType(type, deviation.deviationId);
    const streamTotal = streamSelectors.getTotal(state, streamId);
    // fall back to deviation stats as default
    if (streamTotal === undefined) {
        const stats = _object_spread({}, deviation.stats, deviation.extended && deviation.extended.stats);
        return stats[statMap[type]] || 0;
    }
    return streamTotal;
}
export function getUserStreamContents(state, type, deviation) {
    const streamId = getStreamIdForType(type, deviation.deviationId);
    return {
        streamId,
        users: streamSelectors.getItems(state, streamId),
        isFetching: streamSelectors.isFetching(state, streamId),
        isInitialized: streamSelectors.isInitialized(state, streamId),
        total: getTotal(state, type, deviation)
    };
}

//# sourceMappingURL=selectors.js.map